import { HttpClient } from "../HttpClient";

export const GetWithdrawPaginatedList = async ({
  searchString,
  status,
  sortColumn = "dateUpdated",
  sortOrder = "desc",
  pageNumber = 1,
  rowsPerPage = 10,
}) => {
  try {
    const { data } = await HttpClient.get("api/withdrawal", {
      params: {
        pageNumber,
        rowsPerPage,
        sortOrder,
        ...(sortColumn && { sortColumn }),
        ...(searchString && { searchString }),
        ...(status && { status }),
      },
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
